import React, { useState } from 'react';
import './FirmNameStep.scss';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useProjectWizard } from '../../contexts/ProjectWizardContext';
import Loader from '../../../../../shared/components/common/loader/Loader';
import { getQuestions } from '../../../../../shared/services/projects/ProjectService';
import { deriveBrandNameFromDomain, getSuggestedDomain } from '../../../../../shared/utils/utils';
import { useAccount } from '../../../../../shared/contexts/account/AccountContexts';
import WizardSuggestionTag from '../suggestion-tag/WizardSuggestionTag';

const FirmNameStep: React.FC = () => {
  const { setActiveStep, setQuestionResponse, setFirmName } = useProjectWizard();
  const [loading, setLoading] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const { t } = useTranslation();
  const { accountResponse } = useAccount();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const [apiError, setApiError] = useState<string | null>(null);
  const suggestedBrandName = deriveBrandNameFromDomain(
    getSuggestedDomain(accountResponse?.email, accountResponse?.language)
  );

  const onSubmit = async (loginFormData: any) => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    setLoading(true);
    const firmName = loginFormData.firmName.trim();
    getQuestions(firmName, false)
      .then((data) => {
        setLoading(false);
        setQuestionResponse(data);
        setActiveStep('QUESTIONS');
        setFirmName(firmName);
      })
      .catch((err) => {
        setLoading(false);
        setApiError(err.message);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <>
      {loading && <Loader loadingLabel="loadingDataThisMayTakeAMoment" />}
      <form onSubmit={handleSubmit(onSubmit)} className="project-wizard__page-box">
        <div className="project-wizard__form">
          <div className="form-box__row">
            <h2>{t('enterBrandName')}</h2>
            <div
              className="project-wizard__desc"
              dangerouslySetInnerHTML={{ __html: t('enterBrandNameDesc') }}
            />
            <div className="form-box__label">{t('brandName')}:</div>
            <div className="wizard-suggestion-field">
              <InputText
                {...register('firmName', {
                  required: t('fieldIsRequired'),
                })}
                placeholder="Example"
                className={`input--xxl ${errors.firmName || apiError ? 'form-box__invalid' : ''}`}
              />
              {errors.firmName && <span>{errors.firmName.message as string}</span>}
            </div>
            <WizardSuggestionTag
              value={suggestedBrandName}
              onApply={(value) => setValue('firmName', value, { shouldValidate: true })}
            />
          </div>
        </div>
        <div className="project-wizard__action">
          <Button className="btn btn--xxl" type="submit" disabled={isSubmitting}>
            {t('next')}
          </Button>
          <div className="project-wizard__link">
            {t('linkToDomainStep')}
            <Button
              className="btn--link btn--link-black"
              label={t('clickHere')}
              onClick={() => setActiveStep('DOMAIN')}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default FirmNameStep;
